/*
 * Copyright (c) 2022 E-WIND - Thais Watanabe.
 * All rights reserved.
 */
import React from "react";

/**
 * The EditInspectionItemOptions component
 *
 * @author Thais Watanabe
 */
const Options = (props) => {
  const {
    child,
    position,
    setChildrenResults,
    editedChildResults,
    selectedOption,
  } = props;

  /**
   * hasErrorsChildForm
   * @param {*} position
   */
  function hasErrorsChildForm(position) {
    if (!editedChildResults) {
      return false;
    }

    if (selectedOption !== "不要") {
      if (!editedChildResults[position]) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  /* number - default result */
  if (child.resultType === "number" || child.resultType === "text") {
    return (
      <div position={position}>
        <label
          htmlFor={child.id}
          className="block text-sm font-medium text-gray-900"
        >
          {child.name}
        </label>
        <div className="mt-1 relative">
          <input
            type={child.resultType === "text" ? "text" : "number"}
            id={child.id}
            name={child.id}
            className={`${
              hasErrorsChildForm(position)
                ? "pr-10 border-red-300 text-red-900 placeholder-red-300 focus:outline-none focus:ring-red-500 focus:border-red-50"
                : "focus:ring-teal-500 focus:border-teal-500 border-gray-300"
            } block w-full shadow-sm sm:text-sm rounded-md`}
            value={editedChildResults ? editedChildResults[position] : ""}
            onChange={(e) => setChildrenResults(position, e.target.value)}
          />
          <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
            <span className="text-gray-500 sm:text-sm" id={"unit" + child.id}>
              {child.unit}
            </span>
          </div>
        </div>
        <p className="mt-2 text-sm text-gray-500" id="email-description">
          判定基準：{child.judgement}
        </p>
        {hasErrorsChildForm(position) && (
          <p className="mt-2 text-sm text-red-600" id={"error" + child.id}>
            「{child.title} {child.description}
            」を入力してください
          </p>
        )}
      </div>
    );
  } else {
    return (
      <div position={position}>
        <label
          htmlFor={child.id}
          className="block text-sm font-medium text-gray-900"
        >
          {child.name}
        </label>
        <div className="mt-1">
          <select
            autoComplete={child.id}
            id={child.id}
            name={child.id}
            className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-teal-500 focus:border-teal-500 sm:text-sm"
            value={editedChildResults ? editedChildResults[position] : ""}
            onChange={(e) =>
              setChildrenResults(position, e.currentTarget.value)
            }
          >
            {/* chip */}
            {child.resultType === "chip" && (
              <>
                <option>適合</option>
                <option>整備後適合</option>
                <option>経過観察</option>
                <option>不適合</option>
                <option>点検不要</option>
              </>
            )}
            {/* editor */}
            {child.resultType === "editor" && (
              <>
                <option>済</option>
                <option>未済</option>
              </>
            )}
            {/* exchange */}
            {child.resultType === "exchange" && (
              <>
                <option>未済</option>
                <option>未実施</option>
              </>
            )}
            {/* existence */}
            {child.resultType === "existence" && (
              <>
                <option>あり</option>
                <option>なし</option>
              </>
            )}
            {/* replenishment */}
            {child.resultType === "replenishment" && (
              <>
                <option>補充実施</option>
                <option>補充不要</option>
              </>
            )}
            {/* test */}
            {child.resultType === "test" && (
              <>
                <option>成功</option>
                <option>失敗</option>
              </>
            )}
          </select>
        </div>
      </div>
    );
  }
};

export default Options;
